export default [
    {
        path: '/:organisation/account/settings',
        name: 'accounts.settings',
        component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/account/settings.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
];
